import styled from 'styled-components'
import { Box } from 'src/components'

export const OverSection = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    scroll-behavior: smooth;
`
